import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Investor } from '../modules/shared/models/investor';
import { AuthService } from '../core/auth.service';
import { User } from '../core/user';
import * as XLSX from 'xlsx';

@Injectable()
export class CategoryDataService {
  user: User;
  // private investorCollection: AngularFirestoreCollection<Investor>;
  // list: AngularFirestoreCollection<Investor>;
  constructor(private afs: AngularFirestore, private authService: AuthService) {
    // this.investorCollection = this.afs.collection<Investor>('InvestorData');
    authService.getCurrentUser().subscribe(user => {
      this.user = user;
    });
  }

  addCategoryData(data, category, callback, errorCallback) {
    // console.log("SAVING", "adding category", data)
    // data.searchName = data.name.toLocaleLowerCase();
    // const cleanData = JSON.parse(JSON.stringify(data));
    // cleanData.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    // cleanData.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    // cleanData.RAName = this.user.displayName;
    // console.log(cleanData);
    if (!this.user.displayName) {
      console.log("display name not found");
      return;
    }
    // console.log(this.user.displayName);
    console.log(data, category);

    this.afs.doc<Object>(`CategoryData/${category}`).set(
      {
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        data: data,
        updatedBy: this.user.uid,
      },
      {
        merge: false
      }
   ).then(callback).catch(errorCallback);
  }
  getCategoryByKey(category: string) {
    return this.afs.doc<Object>(`CategoryData/${category}`).ref;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/category-data.service.ts